import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../Interceptors/Interceptor";
import axios from "axios";
import ImageLoad from "./utils/ImageLoad";
import { useDispatch, useSelector } from "react-redux";
import { homeActions } from "../../store/slice/home-slice";
import { Spinner } from "react-bootstrap";


const pageSize = 24;
const TopCategories = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  // const [displayedItems, setDisplayedItems] = useState([]);
  // const [value, setValue] = useState("");
  // const [loading, setLoading] = useState(true);
  // const [searchResults, setSearchResults] = useState([]);

  const dispatch = useDispatch();
  const hotCategoriesList = useSelector(data => data.home.hotCategoriesList);


  useEffect(() => {
    const source = axios.CancelToken.source();
    async function fetchData() {
      try {
        api.get(
          "/api/app/Categories/LoadCategoriesByPriority",
          {
            cancelToken: source.token,
            params: {
              pageSize: pageSize,
              pageNo: 0
            }
          }
        ).then(response => {

          const data = response.data;
          // console.log(data);
          // setItems(data);
          dispatch(homeActions.setHotCategoriesList(data));
          // setTotalProducts(data.length);
          // setDataIsLoaded(true);
        })
          .catch(err => {
            console.log(err);
          });
        // setDisplayedItems(data.slice(0, 40));
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    }

    fetchData();

    return () => {
      source.cancel("UnMounting ..")
    }
  }, []);

  const searchCatOnClick = (id, e) => {
    const params = { type: "category", id: id + "" };
    navigate("/shop", { state: params });
  };



  // function fetchSearchResults(searchTerm) {
  //   setLoading(true);

  //   api.get(
  //     `/api/app/Products/SearchProducts/${searchTerm}`
  //   ).then(response => {
  //     const data = response.data;
  //     setSearchResults(data);
  //   })
  //     .catch(err => {
  //       console.log(err);
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // }

  function navigateToCategory(id) {
    const params = { type: "category", id: id };
    navigate("/shop", { state: params });
  }
  // const onChange = (event) => {
  //   const searchTerm = event.target.value.toLowerCase();
  //   // setValue(searchTerm);
  //   if (searchTerm !== "") {
  //     // fetchSearchResults(searchTerm);
  //   } else {
  //     setSearchResults([]);
  //   }
  // };

  const [pageNo, setPageNo] = useState(0);
  const [isCategoriesLoading, setIsCategoriesLoading] = useState(false);
  async function FetchMoreProducts() {
    const newPageNo = pageNo + 1;
    setPageNo(newPageNo);
    setIsCategoriesLoading(true);
    api.get(
      "/api/app/Categories/LoadCategoriesByPriority",
      {
        params: {
          pageSize: pageSize,
          pageNo: newPageNo
        }
      }
    ).then(response => {

      const resData = response.data;
      console.log(resData);
      // setItems(c => {
      //   return [...c, ...resData]
      // });
      if (resData.length > 0) {
        dispatch(homeActions.addMoreHotCategoriesList(resData));

      }

      // setTotalProducts(data.length);
      // setDataIsLoaded(true);
    })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        setIsCategoriesLoading(false);
      })

  }
  const [open, setOpen] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <div>

      <div>

        {/* <ImageSlides /> */}
        {/* <section className="home-slider position-relative mb-30">
          <div className="container">
            <div className="home-slide-cover mt-30">
              <div className="hero-slider-1 style-4 dot-style-1 dot-style-1-position-1">
                <div
                  className="single-hero-slider single-animation-wrap"
                  style={{
                    backgroundImage: "url(assets/imgs/slider/slider-1.png)",
                  }}
                >
                  <div className="slider-content">
                    <h1 className="display-2 mb-40">
                      Don't miss amazing
                      <br />
                      grocery deals
                    </h1>
                  </div>
                </div>
              </div>
              <div className="slider-arrow hero-slider-1-arrow" />
            </div>
          </div>
        </section> */}

        <section className="popular-categories section-padding" style={{
          minHeight: 619
        }}>
          <div className="container wow animate_animated animate_fadeIn">
            <div className="section-title">
              <div className="title">
                <h3>Featured Categories</h3>
              </div>
              <div
                className="slider-arrow slider-arrow-2 flex-right carausel-10-columns-arrow"
                id="carausel-10-columns-arrows"
              />
            </div>
            <div
            // className="carausel-10-columns-cover position-relative"
            >
              <div
                className="row"
              // className="carausel-10-columns" id="carausel-10-columns"
              >
                {hotCategoriesList
                  // .slice(0, slice)
                  .map(({ count, id, image, name }, i) => (
                    <div key={id} className="col-xl-2 col-xxl-1 col-6 col-lg-2  col-sm-3  " style={{ padding: 5 }}>
                      <a onClick={(e) => {
                        searchCatOnClick(id, e);
                      }}>
                        <div
                          className="card-2    bg-9 wow animate_animated animate_fadeInUp"
                          data-wow-delay=".1s"
                          style={{
                            height: "90%",
                            width: "100%!important",
                            alignItems: 'center'
                          }}
                        >
                          <div className="img-hover-scale overflow-hidden">
                            <React.Fragment>
                              {image ? (
                                <>
                                  <ImageLoad
                                    src={image}
                                    alt={name}
                                    useNoHeight={true}
                                    style={{
                                      width: '90%',
                                      height: '90px',
                                      objectFit: "cover",
                                      borderRadius: 10,
                                    }}
                                  />

                                </>
                              ) : (

                                <div style={{
                                  // width: '90%',
                                  marginLeft: 5,
                                  marginRight: 5,
                                  height: '40px',
                                  // backgroundColor: "#e9ffcb"
                                }} >
                                </div>
                              )}
                            </React.Fragment>
                          </div>
                          <h6 style={{
                            wordWrap: "break-word",
                            // wordBreak: "break-all",

                          }}>
                            <>
                              {/* onClick={(e) => {
                              searchCatOnClick(id, e);
                            }} */}

                              {name}
                            </>
                          </h6>
                          <span>{count} items</span>
                        </div>
                      </a>
                    </div>
                  ))}
              </div>
              <div className="pt-5" style={{ textAlign: "center" }}>
                {
                  isCategoriesLoading ?
                    <Spinner />
                    :
                    <a onClick={FetchMoreProducts}
                      style={{
                        display: "inline-block", border: "1px solid #ccc", padding: 10, borderRadius: 10,
                        paddingLeft: 20,
                        paddingRight: 20,
                      }} >
                      Load More Categories
                    </a>
                }
              </div>
            </div>
          </div>
        </section >
      </div >
    </div >
  );
};

export default TopCategories;
